import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { authService } from "../services/auth";
import { AUTH_EVENT, USER_TYPE } from "../services/config";
import { getStoredProfile, setStoredProfile, getRawToken } from "../services/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [profile, setProfileState] = useState(() => (getRawToken() ? getStoredProfile() : null));

  // sync เมื่อ token/โปรไฟล์เปลี่ยน (login, logout, token หมดอายุ, แท็บอื่น)
  useEffect(() => {
    const sync = () => setProfileState(getRawToken() ? getStoredProfile() : null);
    window.addEventListener(AUTH_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(AUTH_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  // ตอนเปิดแอป: ถ้ามี token ให้รีเฟรชโปรไฟล์จริงจาก Backend
  useEffect(() => {
    if (getRawToken()) authService.refreshProfile().catch(() => {});
  }, []);

  const refresh = useCallback(() => authService.refreshProfile(), []);
  const logout = useCallback(() => authService.logout(), []);

  /** อัปเดตยอดคอยน์ทันทีหลังใช้/ได้รับ (ไม่ต้องรอรีเฟรช) */
  const setCoins = useCallback((tokensLeft) => {
    const next = { ...(getStoredProfile() || {}), tokensLeft };
    setStoredProfile(next);
    setProfileState(next);
  }, []);

  const value = useMemo(
    () => ({
      profile,
      isLoggedIn: !!profile,
      isSuperUser: profile?.user_type === USER_TYPE.superUser,
      coins: profile?.tokensLeft ?? 0,
      refresh,
      logout,
      setCoins,
    }),
    [profile, refresh, logout, setCoins]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
